import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CatalogFactoryComponent } from "~app/modules/catalog/components";

const routes: Routes = [
  { path: '', component: CatalogFactoryComponent },
  { path: ':slug', component: CatalogFactoryComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CatalogRoutingModule {
}
